module.exports = __webpack_public_path__ + "static/media/07_plantilla_cuadrada_combo_simple_cp_gaseosas_lata_220_cc_coffee.50a1ffbc.png";